import LoadingDots from 'components/LoadingDots';
import useClickOutside from 'hooks/useClickOutside';
import React, { MutableRefObject, forwardRef, useRef } from 'react';
import { OutlinedIconType } from 'reusable-components/icons/IconType';
import { useTrekker } from 'utils/analytics';
import ChevronIcon from '~/reusable-components/icons/fullcolor/ChevronIcon';

const CSS = require('./PopoverInput.module.scss');

interface PopoverInputProps {
  icon?: (props: OutlinedIconType) => JSX.Element;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  hasError?: boolean;
  children: React.ReactNode;
  testId?: string;
  isLoading?: boolean;
}

const PopoverInput = forwardRef(
  (
    {
      icon: Icon,
      value,
      placeholder,
      disabled,
      hasError,
      children,
      testId,
      isLoading,
    }: PopoverInputProps,
    ref: MutableRefObject<any>,
  ) => {
    const [showPopover, setShowPopover] = React.useState(false);
    const popoverRef = useRef(null);
    useClickOutside(popoverRef, () => setShowPopover(false));
    const trekker = useTrekker();

    const togglePopover = () => {
      setShowPopover((prevState) => !prevState);
      trekker.event('click', {
        component: ['popover-input'],
        buttonText: placeholder,
        action: showPopover ? 'close' : 'open',
      });
    };
    return (
      <div className={CSS.PopoverInput} ref={popoverRef}>
        <button
          ref={ref}
          className={CSS.PopoverInputButton}
          disabled={disabled}
          onClick={togglePopover}
          data-variant={hasError && 'error'}
          data-test-id={testId}
        >
          {Icon && (
            <span className={CSS.IconContainer}>
              <Icon
                className={CSS.Icon}
                width={24}
                height={24}
                variant={hasError ? 'error' : 'pink'}
              />
            </span>
          )}
          <span className={CSS.Text}>{value || placeholder}</span>
          <span className={CSS.IconContainer}>
            <ChevronIcon
              className={CSS.ChevronIcon}
              direction={showPopover ? 'up' : 'down'}
              width={16}
              height={16}
            />
          </span>
        </button>
        {showPopover && (
          <div className={CSS.Popover}>
            {isLoading ? <LoadingDots size="s" /> : children}
          </div>
        )}
      </div>
    );
  },
);

export default PopoverInput;
